import ApiClient from '~/ApiClient';

import Currency from './Currency';

interface Result {
	items: Currency;
}

export default async function findCurrencies(client: ApiClient): Promise<Result> {
	const request = await client.fetch('currencies');
	const response = await request.json();
	return {
		items: response.items.map((currency: { code: string }) => new Currency(currency.code)),
	};
}
